export enum LookupTypeEnum {
  APPOINTMENT_TYPE = "appointmentType",
  SESSION_TIMEOUT_IN_MIN = 'sessionTimeoutMinutes'
}
